"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREDIT_CARD_TYPE = void 0;
exports.CREDIT_CARD_TYPE = {
    VISA: 'VISA',
    AMEX: 'AMEX',
    MASTERCARD: 'MASTERCARD',
    AMERICAN_EXPRESS: 'AMERICAN_EXPRESS',
    DINERS_CLUB: 'DINERS_CLUB',
    DISCOVER: 'DISCOVER',
    JCB: 'JCB',
    UNIONPAY: 'UNIONPAY',
    MAESTRO: 'MAESTRO',
    ELO: 'ELO',
    MIR: 'MIR',
    HIPER: 'HIPER',
    HIPERCARD: 'HIPERCARD',
    UNKNOWN: 'UNKNOWN'
};
//# sourceMappingURL=creditCardType.js.map